import { stringifyGraph } from '@/clients/http'
import { OrderModel as OrderApiClient } from '@/http/models/Order/Order'
import { format } from 'date-fns'
import { DateRange } from 'react-day-picker'

import { useFetchList } from '@/hooks/useFetchList'

import { OrderHttpParams } from '@/types/http-params/OrderHttpParams'
import { OrderModel } from '@/types/model/Order'

export interface OrderListFilters {
  search?: string
  status?: string
  payment_status?: string
  payment_method?: string
  dateRange?: DateRange
}

export const orderInitialFilters: OrderListFilters = {
  search: '',
  status: undefined,
  payment_status: undefined,
  payment_method: undefined,
  dateRange: undefined,
}

interface UseFetchOrdersProps {
  sort?: string | null
  shouldFetchList?: boolean
}

export const useFetchOrders = ({ sort, shouldFetchList = true }: UseFetchOrdersProps = {}) => {
  return useFetchList<OrderListFilters, OrderModel.Order, {}, any, typeof OrderApiClient.getList>({
    pageSize: 10,
    initialFilters: orderInitialFilters,
    fetchFunction: OrderApiClient.getList,
    sort,
    register: shouldFetchList,
    buildQueryParams: (filters): Partial<OrderHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      status: filters.status || undefined,
      payment_status: filters.payment_status || undefined,
      payment_method: filters.payment_method || undefined,
      start_date: filters.dateRange?.from
        ? format(filters.dateRange.from, 'yyyy-MM-dd')
        : undefined,
      end_date: filters.dateRange?.to ? format(filters.dateRange.to, 'yyyy-MM-dd') : undefined,
      graph_enc: stringifyGraph({
        '*': true,
        order_ref: true,
        quantity: true,
        total: true,
        status: true,
        payment_method: true,
        payment_status: true,
        delivered_at: true,
        order_note_id: { '*': true },
        order_source_id: { '*': true },
        _timestamps: true,
      }),
    }),
    buildParams: () => ({}),
  })
}
